import React from "react";
import { string, bool } from "prop-types";

import DartyLogo from "@components/shared/Icons/Darty";
import FnacLogo from "@components/shared/Icons/FNAC";
import DartyFnacLogos from "@components/shared/Icons/FnacDarty";
import Icon from "./Icons/Icon";

import { getIsCountry, COUNTRIES } from "@lib/getIsCountry";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";

const FnacDartyIconContainer = ({ dataId, isOrientationHorizontal = true }) => {
  if (getIsCountry(COUNTRIES.IT)) {
    return (
      <img
        width={40}
        height={40}
        data-id={dataId}
        src={getStaticAssetURL(`/images/testDrive/Logo_W3.png`)}
      />
    );
  } else if (
    getIsCountry(COUNTRIES.ES) ||
    getIsCountry(COUNTRIES.BE) ||
    getIsCountry(COUNTRIES.PT)
  ) {
    return <Icon className="size-10" icon={<FnacLogo data-id={dataId} />} />;
  } else if (isOrientationHorizontal) {
    return (
      <Icon className="w-10 h-25" icon={<DartyFnacLogos data-id={dataId} />} />
    );
  } else if (!isOrientationHorizontal) {
    return (
      <>
        <DartyLogo width="40px" height="40px" data-id={dataId} />
        <Icon className="size-10 p-1" icon={<FnacLogo data-id={dataId} />} />
      </>
    );
  }
};

FnacDartyIconContainer.propTypes = {
  dataId: string.isRequired,
  isOrientationHorizontal: bool,
};

export default FnacDartyIconContainer;
